import React from 'react';

import BackFlow from './BackFlow';
import FrontFlow from './FrontFlow';

const BusinessInfo = ({
  loanId,
  businessId,
  form,
  flow,
}) => {

  if (flow === 'back') {
    return <BackFlow loanId={loanId} businessId={businessId} form={form} />;
  }

  return <FrontFlow businessId={businessId} form={form} />;
};

export default BusinessInfo;
